import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./reset-user-agent.css";
const container = document.getElementById("root");
createRoot(container).render(_jsx(App, {}));
